import { Switch as HeadlessSwitch } from '@headlessui/react'
import { Fragment } from 'react'

interface SwitchProps {
    checked: boolean
    onChange: (checked: boolean) => void
    label?: string
    description?: string
    disabled?: boolean
}

export default function Switch({ checked, onChange, label, description, disabled = false }: SwitchProps) {
    return (
        <HeadlessSwitch.Group>
            <div className="flex items-center justify-between">
                {(label || description) && (
                    <div className="flex flex-col mr-4">
                        {label && (
                            <HeadlessSwitch.Label className={`text-sm font-medium ${disabled ? 'text-gray-400' : 'text-gray-900'}`}>
                                {label}
                            </HeadlessSwitch.Label>
                        )}
                        {description && (
                            <HeadlessSwitch.Description className="text-xs text-gray-500">
                                {description}
                            </HeadlessSwitch.Description>
                        )}
                    </div>
                )}
                <HeadlessSwitch
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                    className={`${checked ? 'bg-blue-600' : 'bg-gray-200'}
          relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                    <span className="sr-only">Use setting</span>
                    <span
                        aria-hidden="true"
                        className={`${checked ? 'translate-x-5' : 'translate-x-0'}
            pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                    />
                </HeadlessSwitch>
            </div>
        </HeadlessSwitch.Group>
    )
}
